<template>
  <div class="empty-tip">
    <a href="javascript:;" class="icon"></a>
    <p class="content">{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyTip',
  props: {
    content: {
      type: String,
      default: () => {
        return '暂无相关数据';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: -80px;
  margin-left: -80px;
  .icon {
    display: block;
    width: 150px;
    height: 111px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("~@/assets/img/home/icon_empty@2x.png");
    cursor:default;
  }
  .content {
    margin-top: 20px;
    margin-left: 5px;
    font-size: 15px;
    color: rgba(68, 68, 68, 1);
  }
}
</style>
